/* Bundle picker (snippets/yansh-bundle.liquid), 2026-10-28. One decision: the chosen bar sets the size, its slots say
   which edition each deck is (all start as this page's edition). Keeps the summary, mobile bar, button and slot pictures
   in step. Prices: unit x decks minus window.ynOff(n), the one offer rule in yansh-cart-drawer.liquid.
   On submit yansh-cart.js adds window.ynSelfQty() of this edition plus window.ynXsItems() of the others. */
(function(){
  var box=document.getElementById('tiers'),form=document.getElementById('buyForm');
  if(!box||!form||!box.classList.contains('bnd'))return;
  var RU=(box.closest('[lang]')||document.documentElement).lang==='ru';
  var SELF=box.getAttribute('data-self');
  var $=function(id){return document.getElementById(id)};
  function off(n){return window.ynOff?window.ynOff(n):0}
  function free(n){return window.ynFree?window.ynFree(n):0}
  function cur(){return box.querySelector('input:checked')}
  function money(c){return Math.round(c/100)+' ₪'}
  function counts(){
    var r=cur(),n=Number(r.getAttribute('data-n')),o={};
    if(n===1){o[SELF]=1;return o}
    [].forEach.call(r.closest('.bnd-o').querySelectorAll('.bnd-s select'),function(s){o[s.value]=(o[s.value]||0)+1});
    return o;
  }
  function upd(){
    var r=cur();if(!r)return;
    [].forEach.call(box.querySelectorAll('.bnd-o'),function(o){o.classList.toggle('on',o.contains(r))});
    var n=Number(r.getAttribute('data-n')),u=Number(box.getAttribute('data-unit')),c=counts(),parts=[];
    // slot pictures follow the chosen edition
    [].forEach.call(r.closest('.bnd-o').querySelectorAll('.bnd-s'),function(s){
      var op=s.querySelector('select').selectedOptions[0];if(op)s.querySelector('img').src=op.getAttribute('data-img');
    });
    var mixed=Object.keys(c).length>1;
    Object.keys(c).forEach(function(vid){
      var op=box.querySelector('option[value="'+vid+'"]');parts.push(c[vid]+' '+(op?op.getAttribute('data-w'):''))});
    var full=u*n,tot=full-off(n),f=free(n),word=r.getAttribute('data-word');
    var what=mixed?parts.join(' + '):word;
    if($('sum'))$('sum').innerHTML=(RU?'Выбрано: ':'נבחר: ')+what+' '+(f?'<s>'+money(full)+'</s> ':'')+'<b>'+money(tot)+'</b>';
    if($('bbTxt'))$('bbTxt').innerHTML=word+'<b>'+money(tot)+'</b>';
    if($('buyAmt'))$('buyAmt').textContent=money(tot);
    var nd=$('mixNudge');
    if(nd)nd.innerHTML=RU
      ?(f?'<b>'+(f===2?'Две колоды':'Одна колода')+' в подарок.</b> Экономия '+money(off(n))+' и бесплатная доставка.':'<b>Возьмите 3, и третья будет в подарок.</b>')
      :(f?'<b>'+(f===2?'שתי חפיסות מתנה.':'החפיסה השלישית מתנה.')+'</b> חוסכים '+money(off(n))+', והמשלוח חינם.':'<b>קחו 3, והשלישית מתנה.</b> רק עוד '+money(u)+'.');
  }
  box.addEventListener('change',function(e){
    // touching a slot of another bar selects that bar
    if(e.target.tagName==='SELECT'){var r=e.target.closest('.bnd-o').querySelector('input');if(!r.checked)r.checked=true}
    setTimeout(upd);
  });
  form.addEventListener('change',function(){setTimeout(upd)});
  document.addEventListener('DOMContentLoaded',function(){
    window.ynXsItems=function(){var c=counts();return Object.keys(c).filter(function(v){return v!==SELF}).map(function(v){return {id:Number(v),quantity:c[v]}})};
    window.ynSelfQty=function(){return counts()[SELF]||0};
    window.ynXsReset=function(){[].forEach.call(box.querySelectorAll('.bnd-s select'),function(s){s.value=SELF});upd()};
    upd();
  });
})();
